import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { withRequest } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";

class Comprobantes extends Component {
    state = {
        nominas: [{ pagos: [] }],
    };
    componentDidMount() {
        this.getNomina();
    }
    getNomina = async (url = null) => {
        const id = this.props.match.params.id;
        const search = window.location.search ? window.location.search : "";
        url = url ? url : "nominas/" + id + search;
        const nominas = await this.props.request(url);

        if (nominas.success) {
            this.setState({
                nominas: nominas.data,
            });
            //window.print();
        }
    };
    render() {
        const { nominas } = this.state;
        const nomina = nominas[0];

        const combinarPagos = nominas.reduce((acc, nom) => {
            acc = [...acc, ...nom.pagos];
            return acc;
        }, []);

        const empleados = combinarPagos
            .sort((a, b) => {
                return a.nombre < b.nombre ? -1 : 1;
            })
            .reduce((acc, empleado) => {
                if (acc[empleado.cedula] === undefined) {
                    acc[empleado.cedula] = empleado;
                    if (parseFloat(acc[empleado.cedula].toneladas) > 0) {
                        acc[empleado.cedula].totalDescuentos = empleado.descuentos.reduce((carry, desc) => {
                            return carry + parseFloat(desc.monto);
                        }, 0);
                    } else {
                        acc[empleado.cedula].totalDescuentos = 0;
                    }
                } else {
                    acc[empleado.cedula].toneladas =
                        parseFloat(acc[empleado.cedula].toneladas) +
                        parseFloat(empleado.toneladas);
                    acc[empleado.cedula].total =
                        parseFloat(acc[empleado.cedula].total) +
                        parseFloat(empleado.total);
                    acc[empleado.cedula].sueldoBruto =
                        parseFloat(acc[empleado.cedula].sueldoBruto) +
                        parseFloat(empleado.sueldoBruto);
                }
                return acc;
            }, {});

            console.log(empleados);

        const pagos = Object.keys(empleados).reduce((acc, empleado) => {
            acc.push(empleados[empleado]);
            return acc;
        }, []);
        return (
            <div>
                <style>{`@page {size: 8.5in 11in;}`}</style>
                {pagos.map((pago) => {
                    return (
                        <p className='comprobante-pago'>
                            {nomina.tipo === "PROD" ? (
                                <div className='text-center'>
                                    <div>
                                        <strong>COMPROBANTE DE PAGO</strong>
                                    </div>
                                    <div>
                                        <small>
                                            Fecha:{" "}
                                            {new Date().toLocaleString()}
                                        </small>
                                    </div>
                                </div>
                            ) : (
                                <div className='text-center'>
                                    <div>
                                        <strong
                                            style={{
                                                textTransform: "uppercase",
                                            }}>
                                            COMPROBANTE DE PAGO{" "}
                                            {nomina.sucursal.nombre}
                                        </strong>
                                    </div>
                                    <div>
                                        <small>
                                            {nomina.sucursal.direccion} •{" "}
                                            {nomina.sucursal.notas}
                                        </small>
                                    </div>
                                    <div>
                                        <small>
                                            Fecha:{" "}
                                            {new Date().toLocaleString()}
                                        </small>
                                    </div>
                                </div>
                            )}
                            <br />
                            <div>
                                <strong>Nombre:</strong> {pago.nombre}
                            </div>
                            <div>
                                <strong>Código:</strong> {pago.codigo}
                            </div>
                            <div>
                                <strong>Cédula:</strong> {pago.cedula}
                            </div>
                            <div>
                                <strong>Periodo:</strong>{" "}
                                {nomina.fechaInicio} al {nomina.fechaCierre}
                            </div>
                            <br />
                            <table className='table'>
                                <tbody>
                                    <tr>
                                        <th>Producción</th>
                                        <td className='text-right'>
                                            {pago.toneladas} ton.
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Sueldo</th>
                                        <td className='text-right'>
                                            {formatCurrency(
                                                pago.sueldoBruto
                                            )}
                                        </td>
                                    </tr>
                                    {nomina.tipo !== "INFORMALES" && (
                                        <tr>
                                            <th>TSS</th>
                                            <td className='text-right'>
                                                {formatCurrency(pago.tss)}
                                            </td>
                                        </tr>
                                    )}
                                    {pago.descuentos.length > 0 &&
                                        pago.descuentos.map((desc) => (
                                            <tr>
                                                <th>{desc.nombre}</th>
                                                <td className='text-right'>
                                                    {formatCurrency(
                                                        desc.monto
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    {pago.amonestaciones > 0 && (
                                        <tr>
                                            <th>Descuentos</th>
                                            <td className='text-right'>
                                                {formatCurrency(
                                                    pago.amonestaciones
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <th>Total</th>
                                        <td className='text-right'>
                                            {formatCurrency(pago.sueldoBruto > 0 ? pago.sueldoBruto - pago.tss - pago.totalDescuentos : 0)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <br />
                            <hr />
                            <div className='text-center'>
                                Firma Empleado
                            </div>
                        </p>
                    );
                })}

            </div>
        );
    }
}

export default withRouter(withRequest(Comprobantes));
